import { Grid, MenuItem, Select, Typography } from '@mui/material';

import { IScreenOption } from './ScreenConfigSection.interface';

export const ScreenConfigSelect = ({
  label,
  value,
  options = [],
  onChange,
  width,
  disabled,
}: {
  label: string;
  value: string | number;
  options: IScreenOption[];
  onChange: (value: string | number) => void;
  width?: string;
  disabled?: boolean;
}) => {
  return (
    <Grid container justifyContent={'space-between'}>
      {label && (
        <Grid item alignSelf={'center'}>
          <Typography variant="body2" sx={{ color: 'rgba(0, 0, 0, 0.60)' }}>
            {label}
          </Typography>
        </Grid>
      )}

      <Grid item alignSelf={'center'}>
        <Select
          size="small"
          sx={{ width, height: '32px' }}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}>
          {options.map(({ label, value, disabled }) => (
            <MenuItem key={value} value={value} disabled={disabled}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </Grid>
    </Grid>
  );
};
